export const keyToken = "token";

export const getLocalStorageItem = (key: string) => localStorage.getItem(key);

export const setLocalStorageItem = (key: string, value: string) => localStorage.setItem(key, value);

export const deleteLocalStorageItem = (key: string) => localStorage.removeItem(key);

/**
 * Not the session's: kept through a logout. Each entry is keyed by user inside,
 * so the next person to log in on this browser does not inherit anything.
 */
const KEYS_KEPT_ON_LOGOUT = ["tour/planogramExercise/seen"];

export const clearLocalStorage = () => {
  const kept = KEYS_KEPT_ON_LOGOUT.flatMap((key) => {
    const value = localStorage.getItem(key);
    return value === null ? [] : [[key, value] as const];
  });
  localStorage.clear();
  kept.forEach(([key, value]) => localStorage.setItem(key, value));
};

export const setLoginToken = (token: string) => setLocalStorageItem(keyToken, token);

export const getLoginToken = () => getLocalStorageItem(keyToken);

export const removeLoginToken = () => deleteLocalStorageItem(keyToken);
